<template>
   <div class="bottom_">
     <div class="box_">
       <div class="box_i">
         <img :src="logoUrl" alt="">
       </div>
       <div class="box_i box_i_center">
         <p>{{servicePhone}}</p>
         <p><span class="phone_"></span>全国统一客服热线</p>
       </div>
       <!-- <div class="box_i box_i_ma">
         <div class="left_">
           <span>促销活动，随时掌握</span>
           <span><span class="sina_"></span>关注我们的微博</span>
           <span><span class="wechat_"></span>微信公众号</span>
         </div>
         <img src="../../../assets/wxmall/saoma.png" alt="">
       </div> -->
     </div>
     <!-- <p class="copy_">史带中国报备  沪ICP备12009748号-2</p> -->
   </div>
</template>
<style lang="scss" scoped>
   .bottom_{
     box-shadow:0px -1px 8px 0px rgba(0, 0, 0, 0.05);
     margin-top:50px;
     .box_{
       width:1200px;
       display:flex;
       align-items:center;
       margin:0 auto;
       padding:30px 0;
       .box_i{
         flex:1;
         &.box_i_center{
           display:flex;
           align-items: flex-start;
           justify-content: flex-end;
          //  border-left:1px solid rgba(0,0,0,0.1);
          //  border-right:1px solid rgba(0,0,0,0.1);
           flex-direction: column;
           p{
             width: 100%;
              text-align: right;
              justify-content: flex-end;
           }
         }
         img{
           width:247px;
           height:auto;
         }
         p{
           margin:0;
           width:165px;
           text-align:left;
           margin:0 auto;
           &:first-child{
             font-size:25px;
             color:#FF4C1C;
             font-weight:bold;
             white-space:nowrap
           }
           &:last-child{
             font-size:13px;
             color:#000;
             display:flex;
             align-items:center;
             .phone_{
               width:14px;
               height:14px;
               background:url(../../../assets/wxmall/phone.jpg) center center no-repeat;
               background-size:14px 14px;
               display:inline-block;
               margin-right:13px;
             }
           }
         }
       }
     }
     .copy_{
       background-color:#001D3B;
       color:#fff;
       text-align:center;
       margin:0;
       padding:7px 0;
       font-size:12px;
     }
     .box_i.box_i_ma{
       display:flex;
       justify-content: flex-end;
       img{
         width:80px;
         height:auto;
         margin-left:30px;
       }
     }
      .left_ {
        display:flex;
        flex-direction:column;
        align-items: flex-start;
        justify-content: space-between;;
      }
      .left_ span{
        display:flex;
        align-items: center;;
      }
     .left_ span:first-child{
       font-weight:bold;
     }
     .sina_{
        width:25px;
        height:25px;
        background:url(../../../assets/wxmall/sina.png) center center no-repeat;
        background-size:25px 25px;
        display:inline-block;
        margin-right:13px;
     }
     .wechat_{
        width:25px;
        height:25px;
        background:url(../../../assets/wxmall/wechat.png) center center no-repeat;
        background-size:25px 25px;
        display:inline-block;
        margin-right:13px;
     }
   }
</style>
<script>
import api from '@/utils/api'
export default {
    data () {
        return {
          logoUrl:'',
          servicePhone:'',
        }
    },
     mounted (){
      this.fetchData()
    },
    methods: {
      fetchData(){
        let userId = 792713  //后台配置用户:GDSC01 GDsc01-01
        if(window.location.href.indexOf('run4wd') > -1){
          userId = 720369
        }

        api.queryStore({
              userId:userId 
          }).then(res => res.data).then(data => {
              if(data.returnCode === '00' && data.content!=''){
                  this.logoUrl=data.content.coreStoreDto.logoUrl
                  this.servicePhone=data.content.coreStoreDto.servicePhone
              }
        })
      },
    }
}
</script>